// extracted by mini-css-extract-plugin
module.exports = {"languageSwitcherContainer":"LoginApp_languageSwitcherContainer__hRuEd","contentContainer":"LoginApp_contentContainer__Z3EFc"};